export default "__VITE_ASSET__f16f3769__"